import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import clsx from "clsx"
import {
  forwardRef,
  type MouseEvent,
  type MouseEventHandler,
  type SVGAttributes,
  useState
} from "react"

import styles from "./Checkbox.module.css"

export interface CheckboxProps {
  checked?: boolean
  indeterminate?: boolean
  disabled?: boolean
  tabIndex?: number
  variant?: "default" | "error"
  onCheckedChange?: (checked: boolean, event: MouseEvent) => void
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export function Checkbox(props: CheckboxProps) {
  const {
    onCheckedChange,
    onClick,
    indeterminate,
    variant = "default",
    ...otherProps
  } = props

  const [isChecked, setIsChecked] = useState(props.checked)

  // HACK: Radix Checkbox's event doesn't come with value
  function onEvent(event: React.MouseEvent<HTMLButtonElement>) {
    onCheckedChange?.(!isChecked, event)
    setIsChecked(!isChecked)
    onClick?.(event)
  }

  return (
    <CheckboxPrimitive.Root
      {...otherProps}
      className={clsx(styles.root, styles[`variant-${variant}`])}
      onClick={onEvent}
    >
      <CheckboxPrimitive.Indicator asChild>
        {props.indeterminate ? <IndeterminateIcon /> : <CheckIcon />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

const CheckIcon = forwardRef<SVGSVGElement, SVGAttributes<SVGSVGElement>>(
  function CheckIcon(props, ref) {
    return (
      <svg
        {...props}
        fill="none"
        height="18"
        ref={ref}
        viewBox="0 0 18 18"
        width="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 9L8 12L13 6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    )
  }
)

const IndeterminateIcon = forwardRef<
  SVGSVGElement,
  SVGAttributes<SVGSVGElement>
>(function IndeterminateIcon(props, ref) {
  return (
    <svg
      {...props}
      fill="none"
      height="18"
      ref={ref}
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9H13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
})
